import { memo } from "react";
import { DocumentNode } from "@apollo/client";

import useTypedContext from "hooks/useTypedContext";
import TableCell from "components/Table/Cell";
import { TableContext } from "components/Table/Context";
import { ApiKey } from "types/generated";

import { API_KEYS_COLUMN_ID } from "../constants";
import ApiKeysListItemDropdownActionsCell from "./DropdownActionsCell";
import ApiKeysListItemNameCell from "./NameCell";
import ApiKeysListItemTypeCell from "./TypeCell";
import ApiKeysListItemIdCell from "./IdCell";
import ApiKeysListItemGroupsCell from "./GroupsCell";
import ApiKeysListItemCreatorCell from "./CreatorCell";
import ApiKeysListItemCreatedAtCell from "./CreatedAtCell";
import ApiKeysListItemExpiresAtCell from "./ExpiresAtCell";
import ApiKeysListItemLastUsedCell from "./LastUsedCell";

const CELLS = {
  [API_KEYS_COLUMN_ID.NAME]: ApiKeysListItemNameCell,
  [API_KEYS_COLUMN_ID.ID]: ApiKeysListItemIdCell,
  [API_KEYS_COLUMN_ID.TYPE]: ApiKeysListItemTypeCell,
  [API_KEYS_COLUMN_ID.GROUPS]: ApiKeysListItemGroupsCell,
  [API_KEYS_COLUMN_ID.CREATOR]: ApiKeysListItemCreatorCell,
  [API_KEYS_COLUMN_ID.CREATED_AT]: ApiKeysListItemCreatedAtCell,
  [API_KEYS_COLUMN_ID.LAST_USED]: ApiKeysListItemLastUsedCell,
  [API_KEYS_COLUMN_ID.EXPIRES_AT]: ApiKeysListItemExpiresAtCell,
  [API_KEYS_COLUMN_ID.DROPDOWN]: ApiKeysListItemDropdownActionsCell,
};

type ApiKeysListItemProps = {
  apiKey: ApiKey;
  refetchQueriesOnDelete?: DocumentNode[];
  refetchQueriesOnUpdate?: DocumentNode[];
};

const ApiKeysListItem = ({
  apiKey,
  refetchQueriesOnDelete,
  refetchQueriesOnUpdate,
}: ApiKeysListItemProps) => {
  const { visibleColumnIds } = useTypedContext(TableContext);

  return (
    <>
      {visibleColumnIds.map((id) => {
        const Component = CELLS[id as API_KEYS_COLUMN_ID];
        const uniqueKey = `${id}-${apiKey.id}`;

        if (!Component) {
          return null;
        }

        const childrenComponent = (
          <Component
            apiKey={apiKey}
            refetchQueriesOnDelete={refetchQueriesOnDelete}
            refetchQueriesOnUpdate={refetchQueriesOnUpdate}
          />
        );

        return (
          <TableCell key={uniqueKey} id={id}>
            {childrenComponent}
          </TableCell>
        );
      })}
    </>
  );
};

export default memo(ApiKeysListItem);
